export enum DeedType {
    PLANET,
    ROOM,
}
